import _ from 'lodash';

import Station from './Station';

export default {

    getDepartureStationName () {
        return _.result(this.get('origin'), 'getName', null);
    },

    getArrivalStationName () {
        return _.result(this.get('destination'), 'getName', null);
    },

    getViaStationName () {
        return _.result(this.get('via'), 'getName', null);
    },

    getAvoidStationName () {
        return _.result(this.get('avoid'), 'getName', null);
    },

    hasViaStation () {
        return this.getViaStationName() !== null;
    },

    hasAvoidStation () {
        return this.getAvoidStationName() !== null;
    },

    getStationType (station, type) {
        // It's for group stations that don't have validity.
        // Looks like it's a temporary solution.
        if ((station && !station.validity) || (station && station.getIn([ 'validity', type ]))) {
            return station;
        }
        return new Station();
    },

    validateStationsComplete () {
        return !!(this.getIn([ 'origin', 'nlc' ]) && this.getIn([ 'destination', 'nlc' ]));
    },

    validateStationsNotEqual () {
        if (this.validateStationsComplete()) {
            return this.getIn([ 'origin', 'nlc' ]) !== this.getIn([ 'destination', 'nlc' ]);
        }
        return true;
    }

};



// WEBPACK FOOTER //
// ./src/records/SearchMixin.js